import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static targets = ['popover']

  popoverTargetConnected(el) {
    let insidePopover = false
    let insideTrigger = false

    const popover = new bootstrap.Popover(el, {
      html: true,
      trigger: 'manual',
      placement: el.dataset.placement || 'bottom',
      container: 'body',
      sanitize: false
    })

    const hideIfOutside = () => {
      if (!insideTrigger && !insidePopover) popover.hide()
    }

    const bindPopoverHover = () => {
      const tip = popover.tip
      if (!tip || tip._hoverBound) return

      tip.addEventListener('mouseenter', () => { insidePopover = true })
      tip.addEventListener('mouseleave', () => {
        insidePopover = false
        setTimeout(hideIfOutside, 100)
      })
      tip.addEventListener('click', (e) => {
        if (e.target.closest('a')) {
          insidePopover = false
          insideTrigger = false
          popover.hide()
        }
      })
      tip._hoverBound = true
    }

    el.addEventListener('mouseenter', () => {
      insideTrigger = true
      popover.show()
      bindPopoverHover()
    })

    el.addEventListener('mouseleave', () => {
      insideTrigger = false
      setTimeout(hideIfOutside, 100)
    })

    el._popoverInstance = popover
  }

  popoverTargetDisconnected(el) {
    if (el._popoverInstance) {
      el._popoverInstance.dispose()
      el._popoverInstance = null
    }
  }
}
